import React from "react";
import { Box, Heading } from "grommet";
import { EmailForm } from "../../Forms/EmailForm";
import { PasswordForm } from "../../Forms/PasswordForm";
import { PhoneForm } from "../../Forms/PhoneForm";
import { Data } from "../../Settings/Data";
import { Gender } from "../../Settings/Gender";
export var UserSection = function UserSection(_ref) {
  var changeEmailStatus = _ref.changeEmailStatus,
    setNewMail = _ref.setNewMail,
    passwordMessage = _ref.passwordMessage,
    setNewPassword = _ref.setNewPassword,
    passwordError = _ref.passwordError,
    viewCodeParam = _ref.viewCodeParam,
    changePhoneStatus = _ref.changePhoneStatus,
    setViewCodeField = _ref.setViewCodeField,
    setChangePhoneStatus = _ref.setChangePhoneStatus,
    setNewPhone = _ref.setNewPhone,
    sendNewPhoneCode = _ref.sendNewPhoneCode,
    changeCodeStatus = _ref.changeCodeStatus,
    setChangeCodeStatus = _ref.setChangeCodeStatus,
    setNewData = _ref.setNewData,
    message = _ref.message,
    setStatus = _ref.setStatus,
    setMessage = _ref.setMessage;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      Heading,
      {
        level: 2,
        margin: {
          bottom: "3rem",
        },
      },
      "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
    ),
    /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        direction: "column",
        gap: "2rem",
      },
      /*#__PURE__*/ React.createElement(Data, {
        message: message,
        setStatus: setStatus,
        setMessage: setMessage,
        setNewData: setNewData,
      }),
      /*#__PURE__*/ React.createElement(EmailForm, {
        changeEmailStatus: changeEmailStatus,
        setNewMail: setNewMail,
      }),
      /*#__PURE__*/ React.createElement(PhoneForm, {
        viewCodeParam: viewCodeParam,
        setChangeCodeStatus: setChangeCodeStatus,
        changeCodeStatus: changeCodeStatus,
        sendNewPhoneCode: sendNewPhoneCode,
        setNewPhone: setNewPhone,
        changePhoneStatus: changePhoneStatus,
        setViewCodeField: setViewCodeField,
        setChangePhoneStatus: setChangePhoneStatus,
      }),
      /*#__PURE__*/ React.createElement(PasswordForm, {
        passwordMessage: passwordMessage,
        setNewPassword: setNewPassword,
        passwordError: passwordError,
      }),
      /*#__PURE__*/ React.createElement(Gender, {
        setNewData: setNewData,
      })
    )
  );
};
